import { useState, useRef, useEffect } from "react";
import { useIntl } from "react-intl";

import ArrowUpIcon from "../../../assets/icons/ArrowUpIcon";
import SquareIcon from "../../../assets/icons/SquareIcon";
import Spinner from "../../../assets/icons/Spinner";
import label from "../../../i18n/label";
import Message from "../../../i18n/Message";

import "./BuilderInputArea.scss";

const BuilderInputArea = ({
  onSend,
  disabled = false,
  isLoading = false,
  showStop = false,
  stopEnabled = false,
  onStop,
}) => {
  const intl = useIntl();
  const [inputValue, setInputValue] = useState("");
  const textareaRef = useRef(null);
  const [textareaStyles, setTextareaStyles] = useState({});

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (!inputValue.trim() || disabled || isLoading) return;

    onSend(inputValue.trim());
    setInputValue("");
    setTextareaStyles({});
  };

  const handleKeyDown = (e) => {
    if (e.keyCode === 13 && e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  const handleKeyUp = (e) => {
    const elem = e.target;
    if (elem.scrollHeight > elem.clientHeight) {
      if (elem.scrollHeight <= 150) {
        setTextareaStyles({
          overflow: "hidden",
          height: elem.scrollHeight + 2 + "px",
        });
      } else {
        setTextareaStyles({
          overflow: "auto",
          height: "150px",
        });
      }
    }
  };

  const handleChange = (e) => {
    setInputValue(e.target.value);
  };

  // Focus textarea on mount
  useEffect(() => {
    if (textareaRef.current && !disabled) {
      textareaRef.current.focus();
    }
  }, [disabled]);

  const canSend = inputValue.trim() && !disabled && !isLoading;
  const canStop = showStop && stopEnabled;

  return (
    <div className="builder_input_area">
      <form onSubmit={handleSubmit} className="input_form">
        <div className="input_container">
          <textarea
            ref={textareaRef}
            className="message_input"
            value={inputValue}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            onKeyUp={handleKeyUp}
            placeholder={label(
              intl,
              "builder_message_placeholder",
              "Type your message..."
            )}
            disabled={disabled || isLoading}
            rows={1}
            style={textareaStyles}
          />
          <div className="input_actions">
            <span className="hint">
              <Message id="shift_enter_hint" />
            </span>
            <div className="action_buttons">
              {showStop ? (
                <button
                  type="button"
                  className={`stop_button ${canStop ? "active" : ""}`}
                  onClick={onStop}
                  disabled={!canStop}
                  title={label(intl, "stop", "Stop")}
                >
                  <SquareIcon color="" fill="#fff" size={24} />
                </button>
              ) : (
                <button
                  type="submit"
                  className={`send_button ${canSend ? "active" : ""}`}
                  disabled={!canSend}
                >
                  {isLoading ? <Spinner /> : <ArrowUpIcon color="#fff" />}
                </button>
              )}
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default BuilderInputArea;
